import { render } from "./InfoOne.vue?vue&type=template&id=354c740e&scoped=true"
import script from "./InfoOne.vue?vue&type=script&lang=js"
export * from "./InfoOne.vue?vue&type=script&lang=js"

import "./InfoOne.vue?vue&type=style&index=0&id=354c740e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354c740e"]])

export default __exports__